/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect } from 'react'
import { COOKIE_CATEGORIES, getCookiePreferences } from '../../utils/gdprUtils'

function GoogleConsentMode() {
  useEffect(() => {
    const updateConsent = () => {
      const prefs = getCookiePreferences()
      const analyticsGranted = !!(prefs && prefs[COOKIE_CATEGORIES.ANALYTICS])
      const adStorageGranted = !!(prefs && prefs[COOKIE_CATEGORIES.MARKETING])

      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: analyticsGranted ? 'granted' : 'denied',
          ad_storage: adStorageGranted ? 'granted' : 'denied',
        })
      }
    }

    updateConsent()
    window.addEventListener('cookieConsentUpdated', updateConsent)
    return () => window.removeEventListener('cookieConsentUpdated', updateConsent)
  }, [])

  return null
}

export default GoogleConsentMode


